import React from 'react';
import { Modal, Button } from 'tea-component';

interface AutoSaveModalProps {
  visible: boolean;
  onConfirm?: Function | null;
  onClose?: Function | null;
}

const AutoSaveModal: React.FC<AutoSaveModalProps> = (props) => {
  const { visible = false, onConfirm, onClose } = props;
  const handleOnChangeOk = () => {
    onConfirm?.();
  };
  const handleOnChangeCancel = () => {
    onClose?.();
  };

  return (
    <Modal
      className={'dbg-general-modal'}
      visible={visible}
      size={'m'}
      onClose={handleOnChangeCancel}
    >
      <Modal.Body>
        <div className="dbg-common-modal-title">
          {'Recover Previous Session?'}
        </div>
        <div className="dbg-common-modal-content">
          {
            'An autosave is available from your last session. You can choose to continue editing from where you left off or start with a blank page.'
          }
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={handleOnChangeOk}>
          Recover
        </Button>
        <Button type="weak" onClick={handleOnChangeCancel}>
          Discard
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(AutoSaveModal);
